module.exports = __webpack_public_path__ + "media/Components/fonts/boldCinzel-0d2ac0e13d53bb3748e13343f8f05cf2.ttf";